import { Select, SelectProps } from '../../controls/select';
import FieldWrapper, { FieldWrapperProps } from './field-wrapper';
import { useController, UseControllerProps, FieldValues } from 'react-hook-form';

export interface SelectFieldProps<T extends FieldValues, OptionType, IsMulti extends boolean = false>
  extends Omit<UseControllerProps<T>, 'defaultValue'>,
    Omit<SelectProps<OptionType, IsMulti>, 'name'>,
    Omit<FieldWrapperProps, 'children'> {}

export const SelectField = <T extends FieldValues, OptionType, IsMulti extends boolean = false>({
  name,
  label,
  defaultValue,
  required,
  showError,
  layoutForm,
  ...props
}: SelectFieldProps<T, OptionType, IsMulti>) => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    field: { ref: _ref, ...field },
    fieldState: { error }
  } = useController({ name, ...props });

  return (
    <FieldWrapper label={label} error={error} required={required} showError={showError} layoutForm={layoutForm}>
      <Select {...props} {...field} defaultValue={defaultValue} instanceId={`${name}-select`} error={error} />
    </FieldWrapper>
  );
};
